import { useRef, useState, useEffect } from "react"
import ReactDOM from "react-dom"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import "./Select.css"
import { useClickOutside } from "../../hook/useClickOutside"

function Select({ value, options, onChange, style = {} }) {
  const [isOpen, setOpen] = useState(false)
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0, width: 0 })
  const selectRef = useRef(null)
  const dropdownRef = useRef(null)

  useClickOutside([selectRef, dropdownRef], () => setOpen(false));

  function toggleOpen(e) {
    e.stopPropagation()
    if (!isOpen) {
      const rect = selectRef.current.getBoundingClientRect()
      setMenuPosition({
        top: rect.bottom + window.scrollY + 4,
        left: rect.left + window.scrollX,
        width: rect.width
      })
    }
    setOpen(!isOpen)
  }

  if (Array.isArray(options)) {
    const obj = {}
    for (const item of options) obj[item] = item
    options = obj
  }

  useEffect(() => {
    function handleScroll() {
      if (isOpen) setOpen(false)
    }
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [isOpen])

  const dropdown = isOpen ? (
    <div
      ref={dropdownRef}
      className="select-dropdown"
      style={{
        position: "absolute",
        top: `${menuPosition.top}px`,
        left: `${menuPosition.left}px`,
        width: `${menuPosition.width}px`
      }}
    >
      {Object.entries(options).map(([key, label], i) => (
        <div
          key={i}
          className={`select-option ${key === value ? "option-selected" : ""}`}
          onClick={() => {
            console.log("✅ Clicked on:", key)
            onChange(key)
            setOpen(false)
          }}
        >
          {label}
        </div>
      ))}
    </div>
  ) : null

  return (
    <>
      <div
        ref={selectRef}
        className="select"
        style={style}
        onClick={toggleOpen}
      >
        <div className="selected">
          <span>{value}</span>
          <div className={`more-icon ${isOpen ? "more-rotated" : ""}`}>
            <ExpandMoreIcon fontSize="medium" />
          </div>
        </div>
      </div>
      {isOpen && ReactDOM.createPortal(dropdown, document.body)}
    </>
  )
}

export default Select